import Icon from '@/common/components/Icon';
import { Colors } from '../../../../common/colors/colors';
import { IconsWrapper } from '../styles/Test.styles';

export const handleReturnOptions = (ans, removeFunk, editFunk) => {
	return (
		<IconsWrapper>
			<Icon
				name='remove'
				style={{ color: Colors.red, cursor: 'pointer' }}
				onClick={() => removeFunk(ans)}
			/>
			<Icon
				name='edit'
				style={{ color: Colors.yellow, cursor: 'pointer' }}
				onClick={() => editFunk(ans)}
			/>
		</IconsWrapper>
	);
};

export const handleReturnCorrectIcon = (bool) => {
	if (bool) {
		return <Icon name='check' style={{ color: Colors.green }} />;
	}

	return <Icon name='remove' style={{ color: Colors.red }} />;
};
